import GroupedReportView from '../../../components/reports/GroupedReportView';

export function CashFlowStatement() {
  return (
    <GroupedReportView
      title="Statement of Cash Flows"
      description="Indirect method: net surplus adjusted for depreciation, disposal gain/loss, and working-capital movement, split into operating and investing activities. Direct method: operating cash flows grouped by transaction type."
      endpoint="/reports/consolidated/cash-flow"
      filters={['dateRange']}
      supportsComparative
      methodToggle
      xlsx
    />
  );
}
